import { createContext, useMemo, useState } from "react";

export const MessageContext = createContext({
    messages: {},
    setMessages: () => { }
});

//provide messages for multiple components
export default function MessageProvider({ children }) {

    const [messages, setMessages] = useState([]);

    const value = useMemo(
        () => ({ messages, setMessages }),
        [messages]
    );

    return <MessageContext.Provider value={value}>{children}</MessageContext.Provider>
};